import req from "../methods/req"

//读取当前登录用户信息
export const getCurrentUser = function (data) {
    return req({
        url: '/manage/user/getCurrentUser',
        ...data
    })
}

//读取当前登录用户的菜单
export const getCurrentMenu = function (data) {
    return req({
        url: '/manage/menu/getCurrentMenu',
        ...data
    })
}

//编辑当前用户密码
export const modifyPassword = function (data) {
    return req({
        url: '/manage/user/modifyPassword',
        ...data
    })
}

//获取菜单列表
export const getMenuList = function (data) {
    return req({
        url: '/manage/menu/systemMenuList',
        ...data
    })
}

//获取菜单详情
export const getMenuInfo = function (data) {
    return req({
        url: '/manage/menu/systemMenuInfo',
        ...data
    })
}

//新增菜单
export const addMenu = function (data) {
    return req({
        url: '/manage/menu/addSystemMenu',
        ...data
    })
}

//编辑菜单
export const saveMenu = function (data) {
    return req({
        url: '/manage/menu/saveSystemMenu',
        ...data
    })
}

//编辑菜单状态
export const changeMenu = function (data) {
    return req({
        url: '/manage/menu/changeSystemMenu',
        ...data
    })
}

//编辑菜单排序号
export const getSortNumber = function (data) {
    return req({
        url: '/manage/menu/getSortNumber',
        ...data
    })
}

//删除菜单
export const delMenu = function (data) {
    return req({
        url: '/manage/menu/delSystemMenu',
        ...data
    })
}

//获取选择菜单列表
export const selectMenuList = function (data) {
    return req({
        url: '/manage/menu/selectMenuList',
        ...data
    })
}

//获取角色列表
export const systemRoleList = function (data) {
    return req({
        url: '/manage/role/systemRoleList',
        ...data
    })
}

//获取角色详情数据
export const systemRoleInfo = function (data) {
    return req({
        url: '/manage/role/systemRoleInfo',
        ...data
    })
}

//新增角色
export const addSystemRole = function (data) {
    return req({
        url: '/manage/role/addSystemRole',
        ...data
    })
}

//编辑角色
export const saveSystemRole = function (data) {
    return req({
        url: '/manage/role/saveSystemRole',
        ...data
    })
}

//编辑角色状态
export const changeSystemRole = function (data) {
    return req({
        url: '/manage/role/changeSystemRole',
        ...data
    })
}

//删除角色
export const delSystemRole = function (data) {
    return req({
        url: '/manage/role/delSystemRole',
        ...data
    })
}

//选择角色
export const selectRoleList = function (data) {
    return req({
        url: '/manage/role/selectRoleList',
        ...data
    })
}

//用户列表
export const systemUserList = function (data) {
    return req({
        url: '/manage/user/systemUserList',
        ...data
    })
}

//获取用户信息
export const systemUserInfo = function (data) {
    return req({
        url: '/manage/user/systemUserInfo',
        ...data
    })
}

//新增用户
export const addSystemUser = function (data) {
    return req({
        url: '/manage/user/addSystemUser',
        ...data
    })
}

//编辑用户
export const editSystemUser = function (data) {
    return req({
        url: '/manage/user/saveSystemUser',
        ...data
    })
}

//启用禁用用户
export const changeSystemUser = function (data) {
    return req({
        url: '/manage/user/changeSystemUser',
        ...data
    })
}

//删除用户
export const delSystemUser = function (data) {
    return req({
        url: '/manage/user/delSystemUser',
        ...data
    })
}

//重置用户密码
export const resetPassword = function (data) {
    return req({
        url: '/manage/user/resetPassword',
        ...data
    })
}

//重置用户角色
export const resetUserRole = function (data) {
    return req({
        url: '/manage/user/resetUserRole',
        ...data
    })
}

//获取配置
export const getConfig = function (data) {
    return req({
        url: '/manage/config/getConfig',
        ...data
    })
}

//保存配置
export const setConfig = function (data) {
    return req({
        url: '/manage/config/setConfig',
        ...data
    })
}

//获取阶梯奖励配置
export const getContinuous = function (data) {
    return req({
        url: '/manage/config/getContinuous',
        ...data
    })
}

//保存阶梯奖励配置
export const addContinuous = function (data) {
    return req({
        url: '/manage/config/addContinuous',
        ...data
    })
}

//连续签到奖励启用禁用
export const continuousChange = function (data) {
    return req({
        url: '/manage/config/continuousChange',
        ...data
    })
}

//获取签到规则说明
export const getContinuousInstructions = function (data) {
    return req({
        url: '/manage/config/getContinuousInstructions',
        ...data
    })
}

//修改签到规则说明
export const continuousInstructions = function (data) {
    return req({
        url: '/manage/config/continuousInstructions',
        ...data
    })
}

//获取新人奖励配置
export const getNewcomerTask = function (data) {
    return req({
        url: '/manage/config/getNewcomerTask',
        ...data
    })
}

//保存新人奖励配置
export const addNewcomerTask = function (data) {
    return req({
        url: '/manage/config/addNewcomerTask',
        ...data
    })
}
